<template>
    <v-container fluid>
        <v-toolbar class="elevation-1">
            <v-btn
                @click="fab = !fab"
                :color="fab_color"
                dark
                fab
                small
                class="mr-2"
                elevation="1"
            >
                <v-icon size="18" v-if="!fab">mdi-filter-variant</v-icon>
                <v-icon size="18" v-else>close</v-icon>
            </v-btn>
            <v-slide-x-transition>
                <div v-show="fab" style="position: fixed; margin-left: 50px">
                    <v-btn
                        @click.stop="filterOn('today')"
                        :color="status.today ? 'success' : '#999'"
                        rounded
                        dark
                        small
                        class="mx-1"
                        >{{ $t("message.today") }}
                    </v-btn>
                    <v-btn
                        @click.stop="filterOn('future')"
                        :color="status.future ? 'black' : '#999'"
                        rounded
                        dark
                        small
                        class="mx-1"
                        >{{ $t("message.future") }}
                    </v-btn>
                    <v-btn
                        @click.stop="filterOn('expired')"
                        :color="status.expired ? 'error' : '#999'"
                        rounded
                        dark
                        small
                        class="mx-1"
                        >{{ $t("message.expired") }}
                    </v-btn>
                </div>
            </v-slide-x-transition>
            <v-toolbar-title
                v-if="!fab && $vuetify.breakpoint.smAndUp"
                class="ml-2"
            >
                {{ $t("message.Registrations") }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                v-if="
                    $can('create', 'registrations') &&
                    (!$vuetify.breakpoint.smAndDown || !fab)
                "
                @click="newItem()"
                color="primary"
                class="ml-4"
            >
                {{ $t("message.registerButton") }}
            </v-btn>
            <v-dialog
                @keydown.esc="close()"
                v-model="dialog"
                max-width="800"
                persistent
                scrollable
                :transition="
                    $vuetify.breakpoint.smAndDown
                        ? 'slide-y-transition'
                        : 'scale-transition'
                "
                :fullscreen="$vuetify.breakpoint.smAndDown"
            >
                <v-card class="register-card">
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-btn rounded icon @click="close()">
                            <v-icon medium>cancel</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" lazy-validation>
                            <v-container>
                                <v-row justify="center" dense>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined
                                            filled
                                            dense
                                            disabled
                                            :value="truck.company_name"
                                            :label="formHeaders[0].text"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            spellcheck="false"
                                            outlined
                                            dense
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            v-model="truck.notification_email"
                                            :rules="[
                                                rules.required,
                                                rules.max63Chars,
                                                rules.email,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[1].text }}
                                                <strong style="color: red">
                                                    *
                                                </strong>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="truck.reference"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            spellcheck="false"
                                            :rules="[
                                                rules.required,
                                                rules.max127Chars,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[2].text }}
                                                <strong style="color: red">
                                                    *
                                                </strong>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="mb-5">
                                        <v-text-field
                                            spellcheck="false"
                                            outlined
                                            dense
                                            v-model="truck.contact"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            :label="formHeaders[3].text"
                                            :rules="[
                                                rules.max63Chars,
                                                rules.contactAllowedCharacters,
                                            ]"
                                        />
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <v-dialog
                                            v-model="calendar.toggleStart"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="
                                                        calendar.startFormatted
                                                    "
                                                    :rules="[
                                                        rules.required,
                                                        rules.date,
                                                    ]"
                                                    :disabled="
                                                        !$can(
                                                            'update',
                                                            'registrations'
                                                        )
                                                    "
                                                    append-icon="event"
                                                    @click:append="
                                                        toggleCalendarStart()
                                                    "
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[4].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                        >
                                                            *
                                                        </strong>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                ref="calendarStart"
                                                v-model="calendar.start"
                                                scrollable
                                                width="300px"
                                                :min="
                                                    new Date()
                                                        .toISOString()
                                                        .substr(0, 10)
                                                "
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="
                                                        saveCalendarStart(
                                                            calendar.start
                                                        )
                                                    "
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <v-dialog
                                            v-model="calendar.toggleEnd"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="
                                                        calendar.endFormatted
                                                    "
                                                    :rules="[
                                                        rules.required,
                                                        rules.date,
                                                    ]"
                                                    :disabled="
                                                        !$can(
                                                            'update',
                                                            'registrations'
                                                        )
                                                    "
                                                    append-icon="event"
                                                    @click:append="
                                                        toggleCalendarEnd()
                                                    "
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[5].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                        >
                                                            *
                                                        </strong>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                ref="calendarEnd"
                                                v-model="calendar.end"
                                                scrollable
                                                width="300px"
                                                :min="
                                                    new Date()
                                                        .toISOString()
                                                        .substr(0, 10)
                                                "
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="
                                                        saveCalendarEnd(
                                                            calendar.end
                                                        )
                                                    "
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col cols="12" md="3">
                                        <v-dialog
                                            v-model="clock.toggleStart"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="clock.start"
                                                    :rules="[rules.required]"
                                                    append-icon="access_time"
                                                    :disabled="
                                                        !$can(
                                                            'update',
                                                            'registrations'
                                                        )
                                                    "
                                                    @click:append="
                                                        toggleClockStart()
                                                    "
                                                    type="time"
                                                    class="v-text-field-outlined-time"
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[6].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                        >
                                                            *
                                                        </strong>
                                                    </template>
                                                </v-text-field>
                                            </template>

                                            <v-time-picker
                                                ref="timerStart"
                                                v-model="clock.start"
                                                width="300px"
                                                format="24hr"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="toggleClockStart()"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-dialog
                                            v-model="clock.toggleEnd"
                                            width="300px"
                                        >
                                            <template v-slot:activator="{}">
                                                <v-text-field
                                                    outlined
                                                    dense
                                                    v-model="clock.end"
                                                    :rules="[rules.required]"
                                                    append-icon="access_time"
                                                    :disabled="
                                                        !$can(
                                                            'update',
                                                            'registrations'
                                                        )
                                                    "
                                                    @click:append="
                                                        toggleClockEnd()
                                                    "
                                                    type="time"
                                                    class="v-text-field-outlined-time"
                                                >
                                                    <template v-slot:label>
                                                        {{
                                                            formHeaders[7].text
                                                        }}
                                                        <strong
                                                            style="color: red"
                                                        >
                                                            *
                                                        </strong>
                                                    </template>
                                                </v-text-field>
                                            </template>

                                            <v-time-picker
                                                ref="timerEnd"
                                                v-model="clock.end"
                                                width="300px"
                                                format="24hr"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    @click="toggleClockEnd()"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="12" v-if="busy">
                                        <v-slide-y-transition>
                                            <v-alert dense class="warning">
                                                <v-icon class="pr-2">
                                                    warning
                                                </v-icon>
                                                {{ $t("message.Busy") }}
                                            </v-alert>
                                        </v-slide-y-transition>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        :md="
                                            $can('readDocks', 'registrations')
                                                ? 4
                                                : 6
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            spellcheck="false"
                                            v-model="truck.driver"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            :rules="[
                                                rules.max127Chars,
                                                rules.driverAllowedCharacters,
                                            ]"
                                            :label="formHeaders[8].text"
                                        />
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        :md="
                                            $can('readDocks', 'registrations')
                                                ? 4
                                                : 6
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            :value="truck.transp_name"
                                            @input="
                                                v =>
                                                    (truck.transp_name =
                                                        v
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                        v.slice(1))
                                            "
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            autocomplete="off"
                                            :rules="[
                                                rules.required,
                                                rules.max44Chars,
                                                rules.firstChar,
                                                rules.transporterAllowedCharacters,
                                            ]"
                                        >
                                            <template v-slot:label>
                                                {{ $t("message.Transporter") }}
                                                <strong style="color: red">
                                                    *
                                                </strong>
                                            </template>
                                        </v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        :md="
                                            $can('readDocks', 'registrations')
                                                ? 4
                                                : 6
                                        "
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            spellcheck="false"
                                            v-model="truck.license_plate"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            :label="formHeaders[10].text"
                                            :rules="[
                                                rules.max31Chars,
                                                rules.licensePlateAllowedCharacters,
                                            ]"
                                        />
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        v-if="
                                            $can('readDocks', 'registrations')
                                        "
                                    >
                                        <v-select
                                            outlined
                                            dense
                                            v-model="truck.dock"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            :label="formHeaders[9].text"
                                            :items="docks"
                                            type="number"
                                        />
                                    </v-col>

                                    <!-- Type -->
                                    <v-col cols="12" md="6">
                                        <v-select
                                            outlined
                                            dense
                                            v-model="truck.type"
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            :items="types"
                                            item-text="text"
                                            item-value="value"
                                            type="number"
                                            :rules="[rules.required]"
                                        >
                                            <template v-slot:label>
                                                {{ formHeaders[12].text }}
                                                <strong style="color: red">
                                                    *
                                                </strong>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" class="mt-4">
                                        <v-textarea
                                            rows="2"
                                            auto-grow
                                            outlined
                                            dense
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            v-model="truck.remarks_customer"
                                            :label="formHeaders[13].text"
                                            :rules="[rules.max127Chars]"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            rows="2"
                                            auto-grow
                                            v-if="
                                                $can(
                                                    'access',
                                                    'backOfficeRemarks'
                                                )
                                            "
                                            :disabled="
                                                !$can('update', 'registrations')
                                            "
                                            v-model="truck.remarks_backoffice"
                                            :label="formHeaders[14].text"
                                            :rules="[rules.max127Chars]"
                                            outlined
                                            dense
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            v-if="
                                                $can(
                                                    'readHandlingCharges',
                                                    'registrations'
                                                )
                                            "
                                            v-model="truck.handling_charges"
                                            :return-object="false"
                                            :items="getHandlingChargesEntries"
                                            :label="formHeaders[15].text"
                                            outlined
                                            dense
                                            :disabled="
                                                !$can(
                                                    'update',
                                                    'registrations'
                                                ) &&
                                                !$can(
                                                    'updateHandlingCharges',
                                                    'registrations'
                                                )
                                            "
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            v-if="
                                $can('update', 'registrations') ||
                                $can('updateHandlingCharges', 'registrations')
                            "
                            class="list-button"
                            @click="save"
                        >
                            <v-icon class="pr-2" color="success">save</v-icon>
                            {{ $t("message.SaveButton") }}
                        </v-btn>
                        <v-btn class="list-button" @click="close">
                            <v-icon class="pr-2" color="error">cancel</v-icon>
                            {{ $t("message.CancelButton") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="tableHeaders"
            :loading="$store.getters.getLoading"
            :items="items"
            :search="$store.getters.getSearch"
            :lang="this.$i18n.locale"
            class="elevation-5"
            :items-per-page.sync="numItems"
            sort-by="intDate"
            height="calc(100vh - 220px - 40px)"
            fixed-header
            mobile-breakpoint="0"
            :footer-props="$store.getters.getFooterProps"
            :custom-filter="customSearch"
        >
            <template slot="item" slot-scope="props">
                <tr
                    :style="
                        $can('read', 'registrations') ? 'cursor:pointer' : ''
                    "
                    @click="
                        $can('read', 'registrations')
                            ? editItem(props.item)
                            : ''
                    "
                    class="text-no-wrap"
                >
                    <td>
                        <div class="text-uppercase font-weight-bold">
                            <v-icon
                                dark
                                right
                                style="vertical-align: middle; margin: auto"
                                :color="
                                    determineColor(props.item.status.substr(2))
                                "
                            >
                                label
                            </v-icon>
                            {{ $t("message." + props.item.status.substr(2)) }}
                        </div>

                        <div class="body-2">{{ showDates(props.item) }}</div>
                    </td>

                    <td>
                        {{ props.item.arrival_time_from }} -
                        {{ props.item.arrival_time_to }}
                    </td>

                    <td>{{ typeText(props.item.type) }}</td>

                    <td v-if="$can('readDocks', 'registrations')">
                        <div v-if="props.item.dock">{{ props.item.dock }}</div>
                        <div v-else>-</div>
                    </td>
                    <td v-if="$can('readCompanies', 'registrations')">
                        {{ props.item.company_name }}
                    </td>

                    <td>{{ props.item.transp_name }}</td>

                    <td>{{ props.item.reference }}</td>

                    <td>
                        <v-tooltip
                            bottom
                            v-if="
                                props.item.remarks_customer &&
                                props.item.remarks_customer.length > 25
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <div v-on="on">
                                    {{
                                        props.item.remarks_customer.slice(
                                            0,
                                            20
                                        ) + "..."
                                    }}
                                </div>
                            </template>
                            <span>{{ props.item.remarks_customer }}</span>
                        </v-tooltip>
                        <div v-else>{{ props.item.remarks_customer }}</div>
                    </td>

                    <td>{{ props.item.handling_charges }}</td>

                    <td>
                        <v-tooltip
                            bottom
                            v-if="
                                props.item.remarks_backoffice &&
                                props.item.remarks_backoffice.length > 25
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <div v-on="on">
                                    {{
                                        props.item.remarks_backoffice.slice(
                                            0,
                                            20
                                        ) + "..."
                                    }}
                                </div>
                            </template>
                            <span>{{ props.item.remarks_backoffice }}</span>
                        </v-tooltip>
                        <div v-else>{{ props.item.remarks_backoffice }}</div>
                    </td>
                    <td
                        v-if="
                            $can('finish', 'registrations') ||
                            $can('noShow', 'registrations') ||
                            $can('delete', 'registrations')
                        "
                    >
                        <v-btn
                            v-if="$can('finish', 'registrations')"
                            class="caption font-weight-black"
                            small
                            @click.stop="finish(props.item)"
                        >
                            <v-icon class="pr-2" color="success"
                                >check_circle</v-icon
                            >
                            {{ $t("message.FinishButton") }}
                        </v-btn>

                        <v-btn
                            v-if="$can('noShow', 'registrations')"
                            class="caption font-weight-black ml-3"
                            small
                            @click.stop="didNotShow(props.item)"
                        >
                            <v-icon class="pr-2">mdi-alert</v-icon>
                            {{ $t("message.DidNotShowButton") }}
                        </v-btn>

                        <v-btn
                            v-if="$can('delete', 'registrations')"
                            :disabled="
                                $store.getters.getLoggedUserGroup !== 'ADM' &&
                                props.item.company_name !==
                                    $store.getters.getLoggedUserCompany
                            "
                            class="caption font-weight-black ml-3"
                            small
                            @click.stop="deleteItem(props.item)"
                        >
                            <v-icon class="pr-2" color="error">delete</v-icon>
                            {{ $t("message.DeleteButton") }}
                        </v-btn>
                    </td>
                </tr>
            </template>
            <v-alert
                slot="no-data"
                dense
                :value="true"
                class="body-1 my-3 text-capitalize"
                color="warning"
                icon="warning"
            >
                {{ $t("message.NoResults") }}
                {{
                    current_status
                        ? ' for "' + $t("message." + current_status) + '"'
                        : ""
                }}
            </v-alert>
            <v-alert
                slot="no-results"
                dense
                :value="true"
                class="body-1 my-3"
                color="error"
                icon="warning"
            >
                {{ $t("message.YourSearch") }} "{{ $store.getters.getSearch }}"
                {{ $t("message.NoResults") }}
            </v-alert>
        </v-data-table>
    </v-container>
</template>

<script>
import { formatDate, unformatDate } from "../utils/dates";

export default {
    data: () => ({
        firstCharCorrect: true,
        isLoading: false,
        lookup: "",
        fab: true,
        status: {
            today: true,
            expired: false,
            future: false,
        },
        numItems: 35,
        dialog: false,
        editedIndex: -1,
        defaultTruck: {
            company_name: "",
            notification_email: "",
            contact: "",
            arrival_date_from: "",
            arrival_date_to: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            reference: "",
            transp_name: "",
            driver: "",
            license_plate: "",
            dock: "",
            handling_charges: "",
            remarks_customer: "",
            remarks_backoffice: "",
        },
        truck: {
            company_name: "",
            notification_email: "",
            contact: "",
            arrival_date_from: "",
            arrival_date_to: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            reference: "",
            transp_name: "",
            driver: "",
            license_plate: "",
            dock: "",
            handling_charges: "",
            remarks_customer: "",
            remarks_backoffice: "",
            registrationStatus: "",
        },
        types: [
            { text: "Load", value: 5 },
            { text: "Unload", value: 10 },
            { text: "Load & Unload", value: 15 },
        ],
        calendar: {
            toggleStart: false,
            toggleEnd: false,
            start: new Date().toISOString().substr(0, 10),
            end: new Date().toISOString().substr(0, 10),
            startFormatted: null,
            endFormatted: null,
        },
        clock: {
            toggleStart: false,
            toggleEnd: false,
            start: "09:00",
            end: "16:00",
        },
        changed: false,
    }),

    computed: {
        getHandlingChargesEntries() {
            let handlingCharges = [
                ...this.$store.getters.getHandlingChargesEntries,
            ];
            if (
                !handlingCharges.some(
                    item => item.value == this.truck.handling_charges
                )
            ) {
                handlingCharges.push({
                    text: this.truck.handling_charges,
                    value: this.truck.handling_charges,
                });
            }
            return handlingCharges;
        },
        busy() {
            return this.clock.start < "09:00" || this.clock.end > "16:00";
        },
        dateError() {
            const { startFormatted, endFormatted, start, end } = this.calendar;
            const { start: startTime, end: endTime } = this.clock;
            if (!startFormatted || !endFormatted) return false;
            const startDate = unformatDate(startFormatted);
            const endDate = unformatDate(endFormatted);
            const maxTimeFrom = new Date(`${startDate}T23:59`);
            const datetimeFrom = new Date(`${startDate}T${startTime}`);
            const datetimeTo = new Date(`${endDate}T${endTime}`);
            // No error if a registration is being EDITED and the dates haven't changed
            if (
                this.editedIndex !== -1 &&
                start === startDate &&
                end === endDate
            )
                return false;
            // 1. Start and end dates cannot be in the past
            const datetimeNow = new Date();
            // 2. Start date cannot be after end date
            return (
                datetimeTo < datetimeNow ||
                maxTimeFrom < datetimeNow ||
                datetimeFrom > datetimeTo
            );
        },
        current_status() {
            return Object.keys(this.status).find(
                type => this.status[type] === true
            );
        },
        fab_color() {
            return this.current_status
                ? this.determineColor(this.current_status)
                : "primary";
        },
        transporters() {
            return [...this.$store.getters.getTransporter].sort((a, b) => {
                if (a.name < b.name) return -1;
                return Number(a.name > b.name);
            });
        },
        items() {
            return this.$store.getters.getRegistrations.filter(item => {
                const filters =
                    !this.status.today &&
                    !this.status.future &&
                    !this.status.expired;
                return this.status[item.status.substr(2)] || filters;
            });
        },
        rules() {
            return {
                required: value => !!value || this.$t("message.FieldRequired"),
                firstChar: value => {
                    const error = this.$t("message.FirstCharTransporter");
                    return (
                        (value && /^[A-Z-0-9]*$/.test(value.charAt(0))) || error
                    );
                },

                email: value => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return (
                        pattern.test(value) || this.$t("message.InvalidEmail")
                    );
                },
                date: value => {
                    const pattern =
                        /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|40|56|60|64|68|72|76|80|84|88|92|96)$)/;
                    return (
                        pattern.test(value) || this.$t("message.InvalidDate")
                    );
                },
                licensePlateAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9 -]*)$/.test(value) || error;
                },
                driverAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. _-]*)$/.test(value) || error;
                },
                contactAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. _-]*)$/.test(value) || error;
                },
                transporterAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. /()_-]+)$/.test(value) || error;
                },
                max31Chars: value => {
                    const error = this.$t("message.Max31Chars");
                    return !value || value.length <= 31 || error;
                },
                max44Chars: value => {
                    const error = this.$t("message.Max44Chars");
                    return !value || value.length <= 44 || error;
                },
                max63Chars: value => {
                    const error = this.$t("message.Max63Chars");
                    return !value || value.length <= 63 || error;
                },
                max127Chars: value => {
                    const error = this.$t("message.Max127Chars");
                    return !value || value.toString().length < 128 || error;
                },
            };
        },
        formTitle() {
            let title = "";
            if (this.editedIndex === -1) {
                title = this.$t("message.NewRegistration");
            } else if (this.$can("update", "registrations")) {
                title = this.$t("message.EditRegistration");
            } else {
                title = this.$t("message.RegistrationDetails");
            }
            return title;
        },
        tableHeaders() {
            return [
                {
                    text: this.$t("message.Status"),
                    value: "intDate",
                    sortable: true,
                },
                {
                    text: this.$t("message.Time"),
                    value: "arrival_time_from",
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                    sortable: true,
                },
                {
                    text: this.$t("message.Dock"),
                    value: "dock",
                    sortable: true,
                    hidden: !this.$can("readDocks", "registrations"),
                },
                {
                    text: this.$t("message.Company"),
                    value: "company_name",
                    sortable: true,
                    hidden: !this.$can("readCompanies", "registrations"),
                },

                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                    sortable: true,
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                    sortable: true,
                },

                {
                    text: this.$t("message.CustomerRemarks"),
                    value: "remarks_customer",
                    sortable: false,
                },

                {
                    text: this.$t("message.HandlingCharges"),
                    value: "handling_charges",
                    sortable: false,
                },

                {
                    text: this.$t("message.BackOfficeRemarks"),
                    value: "remarks_backoffice",
                    sortable: false,
                },
                {
                    text: this.$t("message.Actions"),
                    value: "actions",
                    sortable: false,
                    hidden:
                        !this.$can("finish", "registrations") &&
                        !this.$can("noShow", "registrations") &&
                        !this.$can("delete", "registrations"),
                },
            ].filter(title => !title.hidden);
        },
        formHeaders() {
            return [
                {
                    text: this.$t("message.Company"),
                    value: "company_name",
                },
                {
                    text: this.$t("message.Email"),
                    value: "email",
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                },
                {
                    text: this.$t("message.ContactPerson"),
                    value: "contact",
                },
                {
                    text: this.$t("message.StartDate"),
                    value: "arrival_date_from",
                },
                {
                    text: this.$t("message.EndDate"),
                    value: "arrival_date_to",
                },
                {
                    text: this.$t("message.ArrivalTimeFrom"),
                    value: "arrival_time_from",
                },
                {
                    text: this.$t("message.ArrivalTimeTo"),
                    value: "arrival_time_to",
                },
                {
                    text: this.$t("message.NameDriver"),
                    value: "driver",
                },
                {
                    text: this.$t("message.Dock"),
                    value: "dock",
                },
                {
                    text: this.$t("message.LicensePlate"),
                    value: "license_plate",
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                },
                {
                    text: this.$t("message.CustomerRemarks"),
                    value: "customer_remarks",
                },
                {
                    text: this.$t("message.BackOfficeRemarks"),
                    value: "remarks_backoffice",
                },
                {
                    text: this.$t("message.HandlingCharges"),
                    value: "handling_charges",
                },
            ];
        },
        docks() {
            const docks = [this.$t("message.NotKnown")];
            for (let i = 1; i <= 26; i += 1) {
                docks.push(i);
            }
            return docks;
        },
        isFilled() {
            return (
                !!this.truck.notification_email &&
                !!this.truck.reference &&
                !!this.truck.transp_name &&
                !!this.truck.type
            );
        },
        isInputValid() {
            return !(
                this.rules.email(this.truck.notification_email) ===
                    this.$t("message.InvalidEmail") ||
                this.rules.date(this.calendar.startFormatted) ===
                    this.$t("message.InvalidDate") ||
                this.rules.date(this.calendar.endFormatted) ===
                    this.$t("message.InvalidDate") ||
                this.rules.transporterAllowedCharacters(
                    this.truck.transp_name
                ) === this.$t("message.SpecialCharacters") ||
                this.rules.licensePlateAllowedCharacters(
                    this.truck.license_plate
                ) === this.$t("message.SpecialCharacters") ||
                this.rules.driverAllowedCharacters(this.truck.driver) ===
                    this.$t("message.SpecialCharacters") ||
                this.rules.contactAllowedCharacters(this.truck.contact) ===
                    this.$t("message.SpecialCharacters") ||
                this.rules.max31Chars(this.truck.license_plate) ===
                    this.$t("message.Max31Chars") ||
                this.rules.max44Chars(this.truck.transp_name) ===
                    this.$t("message.Max44Chars") ||
                this.rules.max63Chars(this.truck.contact) ===
                    this.$t("message.Max63Chars") ||
                this.rules.max63Chars(this.truck.notification_email) ===
                    this.$t("message.Max63Chars") ||
                this.rules.max127Chars(this.truck.driver) ===
                    this.$t("message.Max127Chars") ||
                this.rules.max127Chars(this.truck.reference) ===
                    this.$t("message.Max127Chars") ||
                this.rules.max127Chars(this.truck.remarks_customer) ===
                    this.$t("message.Max127Chars") ||
                this.rules.max127Chars(this.truck.remarks_backoffice) ===
                    this.$t("message.Max127Chars")
            );
        },
        determineColor() {
            return status => {
                switch (status) {
                    case "expired":
                        return "red";
                    case "today":
                        return "green";
                    case "future":
                        return "black";
                    default:
                        return "";
                }
            };
        },
        typeText() {
            return type => {
                const foundType = this.types.find(x => x.value === type);
                if (foundType) return foundType.text;
                return "-";
            };
        },
        showDates() {
            return item => {
                if (item.arrival_date_from === item.arrival_date_to) {
                    return item.arrival_date_from;
                }
                return `${item.arrival_date_from} ${this.$t("message.To")} ${
                    item.arrival_date_to
                }`;
            };
        },
    },
    watch: {
        calendar: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        clock: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        truck: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        dialog(val) {
            if (val) {
                this.changed = false;
                this.setFocus();
            }
        },
        "calendar.start": function () {
            if (
                new Date(this.calendar.start).getTime() >
                new Date(this.calendar.end).getTime()
            ) {
                this.calendar.end = this.calendar.start;
            }
            // Format start date dd/mm/yyyy
            this.calendar.startFormatted = formatDate(this.calendar.start);
        },
        "calendar.end": function () {
            if (
                new Date(this.calendar.end).getTime() <
                new Date(this.calendar.start).getTime()
            ) {
                this.calendar.start = this.calendar.end;
            }
            // Format start date dd/mm/yyyy
            this.calendar.endFormatted = formatDate(this.calendar.end);
        },
        lookup() {
            // Check for rule (capital letter or number)
            this.firstCharCorrect =
                this.lookup && /^[A-Z-0-9]*$/.test(this.lookup.charAt(0));
        },
    },
    mounted() {
        this.$store.dispatch("processRegistrations");
        this.$store.dispatch("processTransporter");
        this.$store.dispatch("processCompanies");

        this.initialize();
    },
    methods: {
        initialize() {
            this.defaultTruck.company_name =
                this.$store.getters.getLoggedUserCompany;
            this.defaultTruck.notification_email =
                this.$store.getters.getLoggedUserEmail;
            this.defaultTruck.contact = this.$store.getters.getLoggedUserName;

            this.calendar.startFormatted = formatDate(this.calendar.start);
            this.calendar.endFormatted = formatDate(this.calendar.end);
        },

        customSearch(value, search, item) {
            return Object.values(item).some(
                v => v && v.toString().toLowerCase().includes(search)
            );
        },

        setFocus() {
            setTimeout(() => {
                this.$refs.form.$children[1].focus();
            }, 0);
        },
        checkNumber(event) {
            if (["+", "-", "e", "E"].includes(event.key)) {
                event.preventDefault();
            }
        },
        filterOn(type) {
            this.status[type] = !this.status[type];
            // Unmark all the rest of the filters
            for (const i in this.status) if (i !== type) this.status[i] = false;
        },
        toggleCalendarStart() {
            this.calendar.toggleStart = !this.calendar.toggleStart;
        },
        toggleCalendarEnd() {
            this.calendar.toggleEnd = !this.calendar.toggleEnd;
        },
        saveCalendarStart(date) {
            this.calendar.startFormatted = formatDate(date);
            this.toggleCalendarStart();
        },
        saveCalendarEnd(date) {
            this.calendar.endFormatted = formatDate(date);
            this.toggleCalendarEnd();
        },
        toggleClockStart() {
            this.clock.toggleStart = !this.clock.toggleStart;
            if (this.$refs.timerStart)
                this.$refs.timerStart.selectingHour = true;
        },
        toggleClockEnd() {
            this.clock.toggleEnd = !this.clock.toggleEnd;
            if (this.$refs.timerEnd) this.$refs.timerEnd.selectingHour = true;
        },
        editItem(item) {
            this.editedIndex =
                this.$store.getters.getRegistrations.indexOf(item);
            this.truck = Object.assign({}, this.defaultTruck, item);
            // Type map with API
            // this.truck.type = this.types[this.truck.type / 5 - 1];

            // Sync clocks
            this.clock.start = this.truck.arrival_time_from;
            this.clock.end = this.truck.arrival_time_to;

            // Sync calendars
            this.calendar.startFormatted = this.truck.arrival_date_from;
            this.calendar.endFormatted = this.truck.arrival_date_to;
            this.calendar.start = unformatDate(this.truck.arrival_date_from);
            this.calendar.end = unformatDate(this.truck.arrival_date_to);

            // Sync dock
            if (!this.truck.dock) this.truck.dock = this.$t("message.NotKnown");

            // Open dialog
            this.dialog = true;
        },
        close() {
            if (
                this.changed &&
                // TODO: USE Alert component instaed
                // eslint-disable-next-line no-restricted-globals, no-alert
                !confirm("Are you sure ? Any unsaved changes will be lost.")
            ) {
                return;
            }

            this.dialog = false;
        },
        newItem() {
            // Clear and assign defaults
            this.truck = Object.assign({}, this.defaultTruck);
            if (this.$refs.form) this.$refs.form.resetValidation();
            // Update calendars
            this.calendar.start = new Date().toISOString().substr(0, 10);
            this.calendar.end = this.calendar.start;
            this.calendar.startFormatted = formatDate(this.calendar.start);
            this.calendar.endFormatted = formatDate(this.calendar.end);
            // Update clocks
            this.clock.start = "09:00";
            this.clock.end = "16:00";
            // New Item mode
            this.editedIndex = -1;
            this.dialog = true;
        },
        async save() {
            // Check form
            if (this.dateError) {
                this.$store.commit("alert", {
                    type: "alert",
                    text: "Datetime cannot be in the past.",
                    color: "error",
                    icon: "mdi-clock",
                });
                return;
            }
            if (!this.isFilled || !this.isInputValid) {
                this.$refs.form.validate();
                return;
            }
            // Save dates and times
            this.truck.arrival_date_from = this.calendar.startFormatted;
            this.truck.arrival_date_to = this.calendar.endFormatted;
            this.truck.arrival_time_from = this.clock.start;
            this.truck.arrival_time_to = this.clock.end;

            // Prepare data for API
            const data = Object.assign(this.truck);
            data.user_id = this.$store.getters.getLoggedUserID;

            // Check if transporter name already exists
            const matchTransporter = transporter => {
                const compareCaseInsensitive =
                    transporter.name.toLowerCase() ===
                    this.truck.transp_name.toLowerCase();
                return compareCaseInsensitive;
            };
            const foundTransporter = this.transporters.find(matchTransporter);
            if (foundTransporter) {
                data.transporter_id = foundTransporter.id;
            } else {
                const response = await this.$store.dispatch("addTransporter", {
                    name: this.truck.transp_name,
                });
                data.transporter_id = response.id;
            }
            data.status = 0;

            // Check dock value
            if (this.truck.dock === this.$t("message.NotKnown")) data.dock = "";

            // Send to API
            if (this.editedIndex > -1) {
                this.$store.dispatch("editRegistration", data);
            } else {
                this.$store.dispatch("addRegistration", data);
            }

            // Close dialog
            this.dialog = false;
        },
        deleteItem(item) {
            this.$store.commit("popUp", {
                type: "deleteRegistration",
                id: item.truck_reg_id,
            });
        },
        finish(item) {
            this.$store.commit("popUp", {
                type: "finish",
                id: item.truck_reg_id,
            });
        },
        didNotShow(item) {
            this.$store.commit("popUp", {
                type: "didNotShow",
                id: item.truck_reg_id,
            });
        },
    },
};
</script>
